/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface VideoVisitConsentResponse {
  /** The ID of the encounter */
  encounter_id: string;
  /** Per-encounter recording consent as a tri-state: True (consented), False (explicitly declined), or None (no decision yet). The transcription/AI gate treats anything but True as not allowed; the None-vs-False distinction lets the in-call consent prompt avoid re-asking a patient who already declined. */
  recording_consent?: boolean | null;
}
